export default __webpack_public_path__ + "static/media/cartoes-poupaclub-removebg.d1c56dc5.png";